import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { closeModal, submitTicketCancellation } from '../../redux/actions';
import { Modal } from '../index';
import {
  CancelingHeading,
  Button,
  ButtonsContainer,
} from './styles';

const mapDispatchToProps = dispatch => bindActionCreators({
  handleCancelTicketSubmit: submitTicketCancellation,
  handleModalClose: closeModal,
}, dispatch);

@connect(null, mapDispatchToProps)
class CancelModal extends PureComponent {
  static propTypes = {
    handleCancelTicketSubmit: PropTypes.func,
    handleModalClose: PropTypes.func,
  };

  handleConfirmTicketCancelClick = () => {
    const { handleCancelTicketSubmit } = this.props;

    handleCancelTicketSubmit();
  };

  render() {
    const { handleConfirmTicketCancelClick } = this;
    const { handleModalClose } = this.props;

    return (
      <Modal empty noButton>
        <CancelingHeading>Are you sure you want to cancel this booking?</CancelingHeading>
        <ButtonsContainer>
          <Button btnType="primary" colorType="danger" onClick={handleConfirmTicketCancelClick}>Yes</Button>
          <Button btnType="primary" onClick={handleModalClose}>No</Button>
        </ButtonsContainer>
      </Modal>
    );
  }
}

export default CancelModal;
